import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { BadeloftPagesRoutingModule } from './badeloft-pages-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CoreComponent } from './core/core.component';
import { StockComponent } from './stock/stock.component';
import { AssignmentComponent } from './assignment/assignment.component';
import { StatusComponent } from './status/status.component';
import { FormsModule } from '@angular/forms';
import { WarehouseComponent } from './warehouse/warehouse.component';
import { IntegrationStatusComponent } from './integration-status/integration-status.component';
import { ConnectionStatusComponent } from './connection-status/connection-status.component';
import { CallbackComponent } from './callback/callback.component';
import { ShopifyConnectionStatusComponent } from './shopify-connection/shopify-connection.component';
import { ShopifyCallbackComponent } from './shopify-callback/shopify-callback.component';
import { OrdersComponent } from './orders/orders.component';
import { OrdersNewComponent } from './orders-new/orders-new.component';
import { ShippedComponent } from './shipped/shipped.component';
import { ReturnComponent } from './return/return.component';
import { SyncDashboardComponent } from './sync-dashboard/sync-dashboard.component';
import { AfterShipSyncComponent } from './aftership-sync/aftership-sync.component';

@NgModule({
  declarations: [
    DashboardComponent,
    CoreComponent,
    StockComponent,
    AssignmentComponent,
    StatusComponent,
    WarehouseComponent,
    IntegrationStatusComponent,
    ConnectionStatusComponent,
    CallbackComponent,
    ShopifyConnectionStatusComponent,
    ShopifyCallbackComponent,
    OrdersComponent,
    OrdersNewComponent,
    ShippedComponent,
    ReturnComponent,
    SyncDashboardComponent,
    AfterShipSyncComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    BadeloftPagesRoutingModule,
  ],
  providers: [DatePipe],
})
export class BadeloftPagesModule {}
